import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import DashboardCard from './DashBoardCard'
import SummaryCards from './SummaryCards'
import { bookedColumnDefs, ColumnDefs1, showValuesByOptions, branchTransferColumnDefs, scTransferReceiveColumnDefs, dispatchColumnDefs, receiveColumnDefs, expectedPackagesColumnDefs, allocationStatusColumnDefs, outDeliveryStatusColumnDefs, returnedStatusColumnDefs, normalDeliveryStatusColumnDefs } from './Constants'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { useSetAtom } from 'jotai'
import useToken from '../../helpers/useTokens'
import { GetRequest, PostRequestCachedV3 } from '../../common/api'
import { branchAll, urls } from '../../common/constants'
import { removeDuplicatesFromArray } from '../../common/helper'

const KenyaDashboard = () => {
    const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), branch:'' })
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    const [showValuesBy, setShowValuesBy] = useState(showValuesByOptions[0])
    const [apiData, setApiData] = useState([])
    const [branchList, setBranchList] = useState([])
    const setAlert = useSetAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    let { loginData = {} } = useToken()
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const obj = {
            intUserID: 0,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1
        }
        PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, obj, true, 24 * 60 * 60)
        .then((res) => {
          setLoader(false)
          if (res.status === 'Success') {
            let branchData = removeDuplicatesFromArray(res?.Data?.Table, 'BranchID')
            const branchNames = branchData.map(item => ({ BranchID: item.BranchID, BranchName: item.BranchName, CityID: item.CityID }));
            setBranchList(branchNames);
            const loginBranch = branchNames?.filter((val) => val.BranchID === loginData?.intBranchID)
            setFilters((prev) => ({ ...prev, branch: loginBranch?.[0] }))
          }else{
             setBranchList([]);
          }
        })
    }, [])

    const handleGoClick = () => {
        try {
            if (Math.abs(moment(filters?.toDate).diff(moment(filters?.fromDate), 'days')) > 31) {
                setAlert({ show: true, msg: 'Selected Date Range is More Than One Month', nextId: '' })
                return
            }
            if (filters?.branch===''||filters?.branch===' ') {
                setAlert({ show: true, msg: 'Please Select Branch', nextId: 'branch' })
                return
            }
            const body = {
                intCompanyID: loginData?.intCompanyID,//data present in 3855
                intBranchID: filters?.branch?.BranchID ,
                DateFrom: moment(new Date(filters?.fromDate)).format('YYYY-MM-DD'),
                DateTo: moment(new Date(filters?.toDate)).format('YYYY-MM-DD')
            }

            setLoader(true)

            GetRequest(urls.getMiniDashboardData, body)
                .then((res) => {
                    setLoader(false)

                    if (res.status !== 'Success') {
                        setAlert({ show: true, msg: res?.ErrMessage || 'Something went wrong', nextId: '' })
                        return
                    }
                    if (!res?.Data?.Table?.length) {
                        setAlert({ show: true, msg: 'No Data Found For Selected Date Range', nextId: '' })
                        return
                    }
                    setApiData(res?.Data?.Table)
                })

        } catch (err) {
            setLoader(false)
            setAlert({ show: true, msg: err.message, nextId: '' })
        }
    }

    const paymentTypeMap = apiData.reduce((acc, item) => {
        acc[item.PaymentTypeName] = item;
        return acc;
    }, {});

    const totals = apiData.reduce((acc, row) => {
        Object.entries(row).forEach(([key, value]) => {
            const num = Number(value);

            if (!isNaN(num)) {
                acc[key] = (acc[key] || 0) + num;
            }
        });

        return acc;
    }, {});

    const getValue = (paymentType, field1, field2, field3) => {
        const fields = [field1, field2, field3];
        const field = fields[showValuesBy?.id] ?? field1;

        return paymentTypeMap[paymentType]?.[field] ?? 0;
    };

    const getTotalValue = (field1, field2, field3) => {
        const fields = [field1, field2, field3];
        const field = fields[showValuesBy?.id] ?? field1;

        return totals?.[field] ?? 0;
    };
    const getNonCodTotalValue = (field1, field2, field3) => {
        const field =
            showValuesBy?.id === 0
                ? field1
                : showValuesBy?.id === 1
                    ? field2
                    : field3;

        return apiData
            .filter(item => item.PaymentTypeName !== 'COD')
            .reduce((sum, item) => sum + (Number(item[field]) || 0), 0);
    };

    const sumRowData = (rowData = {}) =>
        Object.values(rowData).reduce((sum, val) => sum + (Number(val) || 0), 0);

    const formatSlashRowData = (tableCard) =>
        (tableCard?.columnDefs ?? [])
            .map((col) => Number(tableCard.rowData?.[col.dataKey] ?? 0).toLocaleString())
            .join('/');
    const dashboardCards1 = [
        {
            title: 'Booked Packages',
            // mode:'B',
            rowData: {
                Paid: getValue('PAID', 'BookedLRCount', 'BookedUnitsCount', 'BookedNetAmount'),
                COD: getValue('COD', 'BookedLRCount', 'BookedUnitsCount', 'BookedNetAmount'),
                OnAccount: getValue('ONACCOUNT', 'BookedLRCount', 'BookedUnitsCount', 'BookedNetAmount'),
                FOC: getValue('FOC', 'BookedLRCount', 'BookedUnitsCount', 'BookedNetAmount'),
            },
            columnDefs: ColumnDefs1,
            reportColDefs: bookedColumnDefs,
        },
        {
            title: 'Branch Transfer',
            // mode:'SBT',
            rowData: {
                Paid: getValue('PAID', 'BranchTransferLRCount', 'BranchTransferUnitsCount', 'BranchTransferNetAmount'),
                COD: getValue('COD', 'BranchTransferLRCount', 'BranchTransferUnitsCount', 'BranchTransferNetAmount'),
                OnAccount: getValue('ONACCOUNT', 'BranchTransferLRCount', 'BranchTransferUnitsCount', 'BranchTransferNetAmount'),
                FOC: getValue('FOC', 'BranchTransferLRCount', 'BranchTransferUnitsCount', 'BranchTransferNetAmount'),
            },
            columnDefs: ColumnDefs1,
            reportColDefs: branchTransferColumnDefs,
        },
        {
            title: 'SC Trans Received',
            // mode:'SBT',
            rowData: {
                Paid: getValue('PAID', 'SrReceivedLRCount', 'SrReceivedUnitsCount', 'SrReceivedNetAmount'),
                COD: getValue('COD', 'SrReceivedLRCount', 'SrReceivedUnitsCount', 'SrReceivedNetAmount'),
                OnAccount: getValue('ONACCOUNT', 'SrReceivedLRCount', 'SrReceivedUnitsCount', 'SrReceivedNetAmount'),
                FOC: getValue('FOC', 'SrReceivedLRCount', 'SrReceivedUnitsCount', 'SrReceivedNetAmount'),
            },
            columnDefs: ColumnDefs1,
            reportColDefs: scTransferReceiveColumnDefs,
        },
        {
            title: 'Dispatched Packages',
            //  mode:'D',
            rowData: {
                Paid: getValue('PAID', 'DispatchedLRCount', 'DispatchedUnitsCount', 'DispatchedNetAmount'),
                COD: getValue('COD', 'DispatchedLRCount', 'DispatchedUnitsCount', 'DispatchedNetAmount'),
                OnAccount: getValue('ONACCOUNT', 'DispatchedLRCount', 'DispatchedUnitsCount', 'DispatchedNetAmount'),
                FOC: getValue('FOC', 'DispatchedLRCount', 'DispatchedUnitsCount', 'DispatchedNetAmount'),
            },
            columnDefs: ColumnDefs1,
            reportColDefs: dispatchColumnDefs,
        },
        {
            title: 'Received Packages',
            // mode:'R',
            rowData: {
                Paid: getValue('PAID', 'ReceivedLRCount', 'ReceivedUnitsCount', 'ReceivedNetAmount'),
                COD: getValue('COD', 'ReceivedLRCount', 'ReceivedUnitsCount', 'ReceivedNetAmount'),
                OnAccount: getValue('ONACCOUNT', 'ReceivedLRCount', 'ReceivedUnitsCount', 'ReceivedNetAmount'),
                FOC: getValue('FOC', 'ReceivedLRCount', 'ReceivedUnitsCount', 'ReceivedNetAmount'),
            },
            columnDefs: ColumnDefs1,
            reportColDefs: receiveColumnDefs,
        },
        {
            title: 'Expected Packages',
            // mode:'EXP',
            rowData: {
                Paid: getValue('PAID', 'ExpectedReceivedLRCount', 'ExpectedReceivedUnitsCount', 'ExpectedReceivedNetAmount'),
                COD: getValue('COD', 'ExpectedReceivedLRCount', 'ExpectedReceivedUnitsCount', 'ExpectedReceivedNetAmount'),
                OnAccount: getValue('ONACCOUNT', 'ExpectedReceivedLRCount', 'ExpectedReceivedUnitsCount', 'ExpectedReceivedNetAmount'),
                FOC: getValue('FOC', 'ExpectedReceivedLRCount', 'ExpectedReceivedUnitsCount', 'ExpectedReceivedNetAmount'),
            },
            columnDefs: ColumnDefs1,
            reportColDefs: expectedPackagesColumnDefs
        },
        {
            title: 'Allocation Status',
            mode: 'AL',
            rowData: {
                // paymentTypeID:0,
                Received: getTotalValue('ReceivedLRCount', 'ReceivedUnitsCount', 'ReceivedNetAmount'),//paymentTypeID:0, mode:R
                TotalAllocated: getTotalValue('AllocatedLRCount', 'AllocatedUnitsCount', 'AllocatedNetAmount'),//paymentTypeID:0, mode:AL
                ToBeAllocated: getTotalValue('ToBeAllocatedLRCount', 'ToBeAllocatedUnitsCount', 'ToBeAllocatedNetAmount'),//paymentTypeID:0, mode:AL
            },
            columnDefs: [
                { header: 'Received', dataKey: 'Received', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'Total Allocated', dataKey: 'TotalAllocated', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'To Be Allocated', dataKey: 'ToBeAllocated', headerSx: { textAlign: 'center', color: '#444444' } },
            ],
            reportColDefs: allocationStatusColumnDefs
        },
        {
            title: 'Out Delivery Status',
            rowData: {
                // paymentTypeID:0,
                Allocated: getTotalValue('AllocatedLRCount', 'AllocatedUnitsCount', 'AllocatedNetAmount'),//mode:AL
                TotalDelivered: getTotalValue('AllocatedDeliveredLRCount', 'AllocatedDeliveredUnitsCount', 'AllocatedDeliveredNetAmount'),//mode:ALDEL
                ToBeDelivered: getTotalValue('AllocatedToBeDeliveredLRCount', 'AllocatedToBeDeliveredUnitsCount', 'AllocatedToBeDeliveredNetAmount'),//ALTBD
            },
            columnDefs: [
                { header: 'Allocated', dataKey: 'Allocated', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'Total Delivered', dataKey: 'TotalDelivered', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'To Be Delivered', dataKey: 'ToBeDelivered', headerSx: { textAlign: 'center', color: '#444444' } },
            ],
            reportColDefs: outDeliveryStatusColumnDefs
        },
        {
            title: 'Returned Status',
            rowData: {
                // paymentTypeID:0,
                PendingDelivery: getTotalValue('AllocatedToBeDeliveredLRCount', 'AllocatedToBeDeliveredUnitsCount', 'AllocatedToBeDeliveredNetAmount'),//mode:AL
                TotalReturned: getTotalValue('AllocatedReturnedLRCount', 'AllocatedReturnedUnitsCount', 'AllocatedReturnedNetAmount'),//mode:TR
                ToBeReturned: getTotalValue('AllocatedToBeDeliveredLRCount', 'AllocatedToBeDeliveredUnitsCount', 'AllocatedToBeDeliveredNetAmount'),//mode:TBR
            },
            columnDefs: [
                { header: 'Pending Delivery', dataKey: 'PendingDelivery', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'Total Returned', dataKey: 'TotalReturned', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'To Be Returned', dataKey: 'ToBeReturned', headerSx: { textAlign: 'center', color: '#444444' } },
            ],
            reportColDefs: returnedStatusColumnDefs
        },
        {
            title: 'Normal Delivery Status',
            rowData: {
                // paymentTypeID :0,
                Received: getTotalValue('ReceivedLRCount', 'ReceivedUnitsCount', 'ReceivedNetAmount'),//mode:R, paymentTypeID:0
                TotalDelivered: getTotalValue('DeliveredLRCount', 'DeliveredUnitsCount', 'DeliveredNetAmount'),//mode:DEL, paymentTypeID:0
                ToBeDelivered: getTotalValue('ToBeDeliveredLRCount', 'ToBeDeliveredUnitsCount', 'ToBeDeliveredNetAmount'),//mode:TBD, paymentTypeID:0
            },
            columnDefs: [
                { header: 'Received', dataKey: 'Received', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'Total Delivered', dataKey: 'TotalDelivered', headerSx: { textAlign: 'center', color: '#444444' } },
                { header: 'To Be Delivered', dataKey: 'ToBeDelivered', headerSx: { textAlign: 'center', color: '#444444' } },
            ],
            reportColDefs: normalDeliveryStatusColumnDefs
        },
        {
            title: 'COD Collection',
            mode: 'DEL',
            rowData: {
                // paymentTypeID:4,
                CODCollected: getValue(
                    'COD',
                    'DeliveredLRCount',
                    'DeliveredUnitsCount',
                    'DeliveredNetAmount'
                ),//mode:DEL,paymentTypeID:4
                ToBeCollected: getValue(
                    'COD',
                    'ToBeDeliveredLRCount',
                    'ToBeDeliveredUnitsCount',
                    'ToBeDeliveredNetAmount'
                ),//mode:TBDEL ,paymentTypeID:4
            },
            columnDefs: [
                {
                    header: 'COD Collected',
                    dataKey: 'CODCollected',
                    headerSx: { textAlign: 'center', color: '#444444' },
                },
                {
                    header: 'To Be Collected',
                    dataKey: 'ToBeCollected',
                    headerSx: { textAlign: 'center', color: '#444444' },
                },
            ],
            reportColDefs: normalDeliveryStatusColumnDefs
        },
        {
            title: 'Normal Delivery Collection',
            rowData: {
                Collected: getNonCodTotalValue(
                    'DeliveredLRCount',
                    'DeliveredUnitsCount',
                    'DeliveredNetAmount'
                ),//mode:DEL ,paymentTypeID:1
                ToBeCollected: getNonCodTotalValue(
                    'ToBeDeliveredLRCount',
                    'ToBeDeliveredUnitsCount',
                    'ToBeDeliveredNetAmount'
                ),//mode:TBDEL ,paymentTypeID:1
            },
            columnDefs: [
                {
                    header: 'Collected',
                    dataKey: 'Collected',
                    headerSx: { textAlign: 'center', color: '#444444' },
                },
                {
                    header: 'To Be Collected',
                    dataKey: 'ToBeCollected',
                    headerSx: { textAlign: 'center', color: '#444444' },
                },
            ],
            reportColDefs: normalDeliveryStatusColumnDefs
        },
    ];
    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Booking  Date', textAlign: 'left' },
        { field: 'showValuesBy', header: 'Show Values By', textAlign: 'left' },
    ]
    const criteriaData = {
        fromDate: filters?.fromDate.format('DD-MM-YYYY') || '',
        toDate: filters?.toDate.format('DD-MM-YYYY') || '',
        showValuesBy: showValuesBy?.name || '',
        dataType: 'entry',
    }

    const cellValues = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: filters?.branch?.BranchID || 0,
        DateFrom: moment(new Date(filters?.fromDate)).format('YYYY-MM-DD') || '',
        DateTo: moment(new Date(filters?.toDate)).format('YYYY-MM-DD') || '',
    }

    const summaryCardConfig = [
        { key: 'bookedPackages', title: 'Booked Packages', tableTitle: 'Booked Packages', icon: 'Inventory2', color: '#1976d2' },
        { key: 'branchTransfer', title: 'Branch Transfer', tableTitle: 'Branch Transfer', icon: 'LocalShipping', color: '#2e7d32' },
        { key: 'scTrsReceive', title: 'SC Trs Receive', tableTitle: 'SC Trans Received', icon: 'Warehouse', color: '#7b1fa2' },
        { key: 'receivedPackages', title: 'Received Packages', tableTitle: 'Received Packages', icon: 'MoveToInbox', color: '#1565c0' },
        { key: 'dispatchPackages', title: 'Dispatch Packages', tableTitle: 'Dispatched Packages', icon: 'LocalShipping', color: '#f9a825' },
        { key: 'expectedPackages', title: 'Expected Packages', tableTitle: 'Expected Packages', icon: 'AssignmentTurnedIn', color: '#00897b' },
        { key: 'allocationStatus', title: 'Allocation Status', tableTitle: 'Allocation Status', icon: 'PeopleAlt', color: '#ef6c00', valueFormat: 'slash', subtitle: 'RCVD / ALLOC / PEND' },
        { key: 'outDeliveryStatus', title: 'Out Delivery Status', tableTitle: 'Out Delivery Status', icon: 'LocalShipping', color: '#e91e63', valueFormat: 'slash', subtitle: 'ALLOC / DEL / TBD' },
    ]

    const summaryCards = summaryCardConfig.map((config) => {
        const tableCard = dashboardCards1.find((card) => card.title === config.tableTitle)
        return {
            ...config,
            value: config.valueFormat === 'slash'
                ? formatSlashRowData(tableCard)
                : sumRowData(tableCard?.rowData),
        }
    })

    return (
        <Item className="dashboard" sx={{ padding: '0' }}>
            {isSmallScreen && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
            <Item sx={{ padding: '0' }} className="dashboard-controls">
                <Box style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
                    <Box sx={sx.reportFlex}>
                        <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
                            <Datepicker
                                value={filters?.fromDate}
                                name={'from_booking_date'}
                                dateDiff={365}
                                // calcDiffDate(new Date(), new Date("2021,04,01"))
                                label={'From Date'}
                                id={'fromDate'}
                                nextId={'toDate'}
                                prevId={'fromDate'}
                                dateChange={(date) => {
                                    setFilters((prev) => ({ ...prev, fromDate: date }))
                                }}
                                width={'100%'}
                            />
                        </Item>
                        <Item sx={isSmallScreen ? { ...sx.itemsxGrow, maxWidth: '70%' } : sx.itemsxGrow} className="input--container bookingDatePicker">
                            <Datepicker
                                value={filters?.toDate}
                                name={'to_booking_date'}
                                label={'To Date'}
                                id={'toDate'}
                                nextId={'OwnBookingGoBtn'}
                                prevId={'fromDate'}
                                dateChange={(date) => {
                                    setFilters((prev) => ({ ...prev, toDate: date }))
                                }}
                                width={'100%'}
                            />
                        </Item>
                        <Item sx={isSmallScreen ? { ...sx.itemsxGrow, maxWidth: '70%' } : sx.itemsxGrow} className="input--container bookingDatePicker">
                            <DropDownOA
                                label="Branch"
                                id="Branch"
                                nextId={''}
                                prevId={''}
                                data={branchList || []}
                                defaultvalue={filters?.branch?.BranchName || ''}
                                dataKey={`BranchName`}
                                idKey={`BranchID`}
                                onSelect={(val) => setFilters((prev) => ({ ...prev, branch: val }))}
                                onReset={() => setFilters((prev) => ({ ...prev, branch: '' }))}
                                width={'100%'}
                                listWidth={'350px'}
                            />
                        </Item>
                        <Item sx={sx.itemsx}>
                            <Button
                                id="goBtn"
                                variant="contained"
                                className="go click-button"
                                style={{ padding: '5px' }}
                                onClick={handleGoClick}
                            // onKeyDown={(e) => navigation3(e, 'sourceCity', 'fromDate', handleGoClick)}
                            >
                                GO
                            </Button>
                        </Item>
                        <Item sx={sx.itemsxGrow}>
                            <DropDownOA
                                label="Show Values By"
                                id="ShowValuesBy"
                                nextId={''}
                                prevId={''}
                                data={showValuesByOptions || []}
                                defaultvalue={showValuesBy.name || ''}
                                dataKey={`name`}
                                idKey={`id`}
                                onSelect={(val) => setShowValuesBy(val)}
                                width={'100%'}
                                listWidth={'250px'}
                            />
                        </Item>
                    </Box>
                    <Box sx={{ paddingLeft: '22px', paddingRight: '22px' }}>
                        <SummaryCards cards={summaryCards} />
                        <Box
                            sx={{
                                display: 'grid',
                                gap: 2,
                                gridTemplateColumns: {
                                    xs: '1fr',
                                    md: 'repeat(2, 1fr)',
                                    lg: 'repeat(3, 1fr)',
                                },
                            }}
                        >
                            {dashboardCards1.map((card) => (
                                <DashboardCard
                                    key={card.title}
                                    title={card.title}
                                    columnDefs={card.columnDefs}
                                    reportColDefs={card.reportColDefs}
                                    rowData={card.rowData}
                                    cellValues={cellValues}
                                    criteriaHeaders={criteriaHeaders}
                                    criteriaData={criteriaData}
                                />
                            ))}
                        </Box>
                        {isSmallScreen && <Button
                            id='goHomeBtn'
                            variant="contained"
                            className="btn btn-primary"
                            sx={{
                                width: '100%',
                                padding: '10px',
                                letterSpacing: '2px',
                                height: '40px',
                                marginTop: '10px'
                            }}
                        >
                            Go Home
                        </Button>}
                    </Box>
                </Box>
            </Item>
        </Item>
    )
}

export default KenyaDashboard
